var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6336 6.97718L9.13355 18.4772C9.0668 18.544 8.98753 18.597 8.90027 18.6332C8.81302 18.6694 8.71949 18.688 8.62503 18.688C8.53058 18.688 8.43705 18.6694 8.34979 18.6332C8.26254 18.597 8.18327 18.544 8.11652 18.4772L3.08527 13.4459C2.9504 13.3111 2.87463 13.1281 2.87463 12.9374C2.87463 12.7467 2.9504 12.5638 3.08527 12.4289C3.22013 12.294 3.40305 12.2183 3.59378 12.2183C3.78451 12.2183 3.96743 12.294 4.1023 12.4289L8.62503 16.9525L19.6165 5.96015C19.7514 5.82528 19.9343 5.74951 20.125 5.74951C20.3158 5.74951 20.4987 5.82528 20.6336 5.96015C20.7684 6.09501 20.8442 6.27793 20.8442 6.46866C20.8442 6.65939 20.7684 6.84231 20.6336 6.97718Z",
    fill: "#2DB0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c7dd02f46873a1da9ffe53c5178f5f9a.svg";
export { ForwardRef as ReactComponent };